module.exports = __webpack_public_path__ + "static/1-a163143f2ba8c7bcf7777f914ef0dd57.jpeg";